import React, { useEffect } from "react";

import DatatablePage from "../../../layout/datatable-pages/investors";
import { fetchData, getInvestorsFieldsArray } from "../../../utils/helpers";
import { props } from "../../datatable/props";
import useDatatable from "../../hooks/useDatatable";

import "../../data/datatable-pages.css";
import { useSupabaseApp } from "../../../SupabaseApp";

/**
 * LateStage Component (Late Stage Funding Sourcing)
 * 
 * Browse and discover late stage funding sources for mature, Series C+ companies.
 * Users can search through 43+ investor attributes including assets under management,
 * exit history, and investment focus areas. Requires user authentication.
 * 
 * @returns {JSX.Element} Datatable page with late stage funding sources
 */
const LateStage = () => {
  // Array of investor field keys to display in the datatable (43 fields for sourcing)
  const fieldKeys = [
    "name",
    "investorType",
    "description",
    "numOfFailedInvestments",
    "lossOnInvestments",
    "shutteredPortfolioCompanies",
    "numOfExit",
    "exitValue",
    "reputation",
    "location",
    "investmentStage",
    "investmentTrackRecord",
    "assets",
    "investmentRange",
    "sweetSpot",
    "investmentFocus",
    "investmentGeography",
    "numOfInvestments",
    "numOfLeadInvestments",
    "numOfFollowOnInvestments",
    "numOfCoInvestments",
    "numOfAcquisitions",
    "boardSeats",
    "numOfFunds",
    "limitedPartners",
    "coInvestors",
    "numofPartners",
    "partners",
    "numOfEmployeesObj",
    "management",
    "boardMembers",
    "founders",
    "email",
    "socialMedia",
    "website",
    "phone",
    "address",
    "entityType",
    "legalName",
    "primaryBusinessName",
    "formerlegalName",
    "founded",
    "stockSymbol",
  ];

  const fields = getInvestorsFieldsArray(fieldKeys);

  const { datatableProps } = useDatatable();

  // realm functions declaration
  const { currentUser, supabase, getUserTier } = useSupabaseApp();

  // check if user is logged in or not
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  // params for functions
  const params = {
    supabase,
    ...datatableProps,
    getData: "getLateStageFunding",
    collection: "investors",
    title: "Late stage funding",
    datatipText:
      "Search for funding with our founder-friendly collection of family office, private equity, and other late stage funding sources.",
    statsArray: [
      {
        actualName: "financingSources",
        displayName: "Financing sources",
        total: "19,565",
      },
    ],
    placeholderText: "Search from late stage funding",
    fields: fields,
    getCompanyDetailsForExpand: "getCompanyDetailsForExpand",
  };

  // fetch data on page load
  useEffect(() => {
    fetchData(params);
  }, []);

  return <DatatablePage props={props(params)} />;
};

export default LateStage;
